<h5 class="card-title">
    Emails receptor (Buzón de sugerencia)
</h5>
<div class="bar-options" *ngIf="this.nro_emails < 3">
    <div class="row">
        <div class="col text-end">
            <button mat-raised-button class="btn-action1"
                (click)="agregar()">
                <mat-icon matSuffix>add</mat-icon>
                Nuevo Email
            </button>
        </div>
    </div>
</div>
<div class="tablex">
<table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="nro">
        <th mat-header-cell *matHeaderCellDef> Nro. </th>
        <td mat-cell *matCellDef="let element; let i = index;"> {{i+1}} </td>
    </ng-container>
    <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef> Nombre </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
    </ng-container>
    <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email </th>
        <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>
    <ng-container matColumnDef="opciones">
        <th mat-header-cell *matHeaderCellDef>Opciones</th>
        <td mat-cell *matCellDef="let element">
            <button mat-icon-button class="btn-blue"
                    (click)="editar(element.id)"
                    matTooltip="Editar">
                <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button class="color-danger"
                    (click)="eliminar(element.id)"
                    matTooltip="Eliminar">
                <mat-icon>delete</mat-icon>
            </button>
        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
</div>